module.exports = __webpack_public_path__ + "static/media/reno_severino.28a65604.jpg";